Vue.component("registration-tasks", {

    props: ["team"],

    data () {
        return {
            sendingEmail: false
        };
    },

    computed: {

        showBillingInfoTask () {
            return this.team.subscription_status === "new";
        },

        showEFTPaymentPendingTask () {
            return this.team.subscription_status === "subscribed" && this.team.subscription.payment_method === "eft";
        },

        showDebitOrderAuthPendingTask () {
            return this.team.subscription_status === "subscribed" && this.team.subscription.payment_method === "debit order";
        }
    }

});
